// extracted by mini-css-extract-plugin
export default {"body":"error_body__3xnlL","link":"error_link__Y8JSl","menu":"error_menu__6zo9R","container":"error_container__Gj7vv","text":"error_text__ljpj6","image":"error_image__qijzX"};